import * as React from 'react';
import SecondaryCustomizedTablesAdmin from './Element/ExpirationLicenseTable'
import FormsSelector from './Element/FormsSelector'
import FilterTable from './Element/ContainerFilter'

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export default function ExpirationLicensesTable() {
  return (
    <Box>
      <Grid container spacing={5}>
        <Grid item xs={12} sm={12} md={12} lg={12}>
        </Grid>
        <Grid item xs={12} sm={12} md={1} lg={1}>
          <FilterTable></FilterTable>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={6}>
          <SecondaryCustomizedTablesAdmin></SecondaryCustomizedTablesAdmin>
        </Grid>
        <Grid item xs={12} sm={12} md={5} lg={5}>
          <FormsSelector></FormsSelector>
        </Grid>
      </Grid>
    </Box>
  );
}